"use client";

import { BatchProof } from "./BatchProof";
import { useEffect } from "react";

export function Demo() {
  // Load Vimeo player script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div id="earnings-examples" className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-screen-xl mx-auto">
      <div className="lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">

        <div className="mb-10 lg:mb-0 lg:pr-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4 md:mb-6">
            See BatchFinder in Action
          </h2>
          <p className="text-gray-600 text-base sm:text-lg mb-6 md:mb-8">
            Watch how easily BatchFinder automatically accepts profitable batches while you focus on other things.
          </p>

          <div className="max-w-[280px] mx-auto rounded-[2.5rem] overflow-hidden border-8 border-gray-900 shadow-xl">
            <div style={{padding:"177.78% 0 0 0",position:"relative"}}>
              <iframe 
                src="https://player.vimeo.com/video/1130601561?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" 
                frameBorder="0" 
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}} 
                title="BatchFinder Setup Video"
              ></iframe>
            </div>
          </div>
        </div>

        <BatchProof />

      </div>
    </div>
  );
} 